interface BrainAvatarProps {
  color: string;
  size?: "sm" | "md" | "lg";
  status?: "active" | "thinking" | "inactive";
  onClick?: () => void;
}

export const BrainAvatar = ({ 
  color, 
  size = "md", 
  status = "inactive",
  onClick 
}: BrainAvatarProps) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-12 h-12", 
    lg: "w-16 h-16"
  };

  const getStatusStyles = () => {
    switch (status) {
      case "active":
        return "ring-2 ring-brain-active shadow-[0_0_10px_rgba(96,102,241,0.5)]";
      case "thinking":
        return "ring-2 ring-brain-thinking animate-pulse shadow-[0_0_10px_rgba(139,92,246,0.5)]";
      default:
        return "ring-1 ring-brain-inactive";
    }
  };

  return (
    <div
      className={`
        ${sizeClasses[size]} 
        rounded-full 
        ${getStatusStyles()}
        transition-all duration-300
        ${onClick ? "cursor-pointer hover:scale-110" : ""}
      `}
      style={{ backgroundColor: color }}
      onClick={onClick}
    />
  );
};